import React, { ReactNode } from 'react';
import LoggerService from 'services/LoggerService';
import { loggerApi } from 'store/api';

interface IErrorBoundaryProps {
  children: ReactNode;
}

interface IErrorBoundaryState {
  error: boolean;
}

class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
  protected logger = new LoggerService(loggerApi);

  public componentDidCatch(error: Error) {
    this.logger.log(error);
  }

  public render() {
    return this.props.children;
  }
}

export default ErrorBoundary;
